import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

export default function NotFoundPage() {
  return (
    <section className="container-page flex min-h-[60vh] flex-col items-center justify-center gap-4 py-24 text-center">
      <span className="bg-brand-gradient bg-clip-text text-6xl font-black text-transparent">404</span>
      <h1 className="text-2xl font-bold text-ink dark:text-white">Page not found</h1>
      <p className="max-w-md text-sm text-muted dark:text-subtle">
        The page you're looking for doesn't exist or may have moved.
      </p>
      <Link to="/" className="btn-primary mt-2">
        <FiArrowLeft /> Back to home
      </Link>
    </section>
  );
}
